export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/admin',
  endpoints: {
    getToken: 'infosite/token/create',
    supplier: 'infosite/supplier/create',
    career: 'infosite/career/create',
  }
};
